import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.json.stringify.js";
import channelOptions from "../../../components/serverList/channelOptions.vue";
import TimeDateOptions from "../../../components/timeList/timeDateOptions.vue";
import { addNotice, updateNotice } from "@/api/notice";
import { cpInfo } from "@/api/config";
export default {
  components: {
    channelOptions: channelOptions,
    TimeDateOptions: TimeDateOptions
  },
  name: "addNoticenoticeInfo",
  props: {
    msg: Object,
    addOrEdit: Number
  },
  created: function created() {
    this.noticeInfo = JSON.parse(JSON.stringify(this.msg));
    this.initCpInfo();
    if (this.noticeInfo.id) {
      this.timedata = [this.noticeInfo.start_time, this.noticeInfo.end_time];
    } else {
      this.timedata = [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")];
    }
  },
  mounted: function mounted() {
    this.isCreating = false;
  },
  data: function data() {
    return {
      noticeInfo: {},
      isUeditor: false,
      ueditorConfig: {
        serverUrl: "/api/cos/upload2cp",
        UEDITOR_HOME_URL: "/UEditor/" // 需要令此处的URL等于对应 ueditor.config.js 中的配置。
      },

      isCreating: false,
      options: [{
        label: "登录公告",
        value: 1
      }, {
        label: "活动公告",
        value: 2
      }, {
        label: "系统公告",
        value: 3
      }, {
        label: "小报",
        value: 4
      }, {
        label: "开服公告",
        value: 5
      }, {
        label: "更新公告",
        value: 6
      }, {
        label: "游戏声明",
        value: 7
      }],
      timedata: [],
      type: {
        1: "登录公告"
      },
      pop: {
        0: "不弹出",
        1: "弹出"
      },
      status: {
        0: "关闭",
        1: "开启"
      }
    };
  },
  methods: {
    //addOrEdit  =1 添加  =2修改
    initCpInfo: function initCpInfo() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cpInfo(_this.noticeInfo);
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this.isUeditor = res.data.isUeditor;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var channelAry, finishedNum, template, _iterator, _step, channelId, noticeInfo, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.noticeInfo.start_time = _this2.timedata[0];
              _this2.noticeInfo.end_time = _this2.timedata[1];
              if (!(_this2.addOrEdit == 1)) {
                _context2.next = 6;
                break;
              }
              if (!_this2.isCreating) {
                _this2.isCreating = true;
                channelAry = _this2.noticeInfo.channel_id;
                finishedNum = 0;
                if (channelAry.length > 0) {
                  template = JSON.stringify(_this2.noticeInfo);
                  _iterator = _createForOfIteratorHelper(channelAry);
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      channelId = _step.value;
                      noticeInfo = JSON.parse(template);
                      noticeInfo.channel_id = channelId;
                      addNotice(noticeInfo).then(function (res) {
                        if (res.code == 0) {
                          _this2.$message({
                            message: "添加公告成功",
                            type: "success"
                          });
                        } else {
                          _this2.$message.error("添加公告失败");
                        }
                        finishedNum += 1;
                        if (finishedNum == channelAry.length) {
                          _this2.isCreating = false;
                          _this2.$emit("backNotice", false);
                        }
                      });
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
              }

              // const res = await addNotice(this.noticeInfo);
              // if (res.code == 0) {
              //     this.$message({
              //         message: "添加公告成功",
              //         type: "success",
              //     });
              //     this.$emit("backNotice", false);
              // } else {
              //     this.$message.error("添加公告失败");
              // }
              _context2.next = 10;
              break;
            case 6:
              _context2.next = 8;
              return updateNotice(_this2.noticeInfo);
            case 8:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.$message({
                  message: "修改公告成功",
                  type: "success"
                });
                _this2.$emit("backNotice", false);
              } else {
                _this2.$message.error("修改公告失败");
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onCancel: function onCancel() {
      this.$emit("onCancel");
    }
  }
};